<template>
    <div class="m-1">
        <small class="flex-grow-0 mr-2 text-secondary">{{ filter.title }}</small>
        <b-form-radio-group
            v-model="value"
            :options="options"
            @change="onFilterChanged" />
    </div>
</template>

<script>
import {DateSubmitProcessor} from "@/utils/dateFormat";

export default {
    name: "DataTableBooleanFilter",
    props: {
        filter: { type: Object, default: () => { return {} } },
        initialValue: { type: Object, default: () => { return {} } },
    },
    data() {
        return {
            value: null,
            options: [
                { text: 'Не задано', value: null },
                { text: 'Да', value: true },
                { text: 'Нет', value: false }
            ],
        }
    },
    computed: {
        label() {
            return `${this.filter.title}: ${this.value ? 'Да' : 'Нет'}`
        }
    },
    methods: {
        reset() {
            this.value = null;
        },
        resetValue(value) {
            this.value = null;
        },
        onFilterChanged() {
            this.$emit('filter-removed', this.filter.name);
            if (this.value !== null) {
                this.$emit('filter-added', this.filter.name, this.value, this.label);
            }

        }
    },
    mounted() {
        if (this.initialValue && this.initialValue.hasOwnProperty('value')) {
            this.value = this.initialValue['value']
        }
    }
}
</script>

<style scoped>

</style>